/* global Config */
// eslint-disable-next-line no-unused-vars

import {AVAIL_ENDPOINT} from '../src/helpers/constants';

const configBase = {
  baseUrl: Config.base.sandwichUrl,
  contentType: 'application/json',
  crossDomain: false,
  method: 'GET',
  responseType: 'json',
  timeout: 90000,
};

export const serviceConfig = {
  AVAIL_COMPARE_BY_ALID: {
    ...configBase,
    params: {page: 0, limit: 1, alid: 'needs to be provided', recordId: 'needs to be provided'},
    path: `${AVAIL_ENDPOINT}/alidcompare`,
  },
  AVAIL_COMPARE_BY_EIDR: {
    ...configBase,
    params: {page: 0, limit: 1, eidr: 'needs to be provided', recordId: 'needs to be provided'},
    path: `${AVAIL_ENDPOINT}/eidrcompare`,
  },
};
